import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AuthGuard } from './pages/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: 'app/pages/login/login.module#LoginModule' },
  { path: 'resetPassword/:email/:token', loadChildren: 'app/pages/resetPassword/reset.module#ResetModule' },
  { path: 'pages', loadChildren: 'app/pages/pages.module#PagesModule',
  canActivate:[AuthGuard] },
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {
  preloadingStrategy: PreloadAllModules,
  useHash: true
});


// WEBPACK FOOTER //
// ./src/app/app.routing.ts